module.exports = __webpack_public_path__ + "img/www.walmart.com.c59df865.png";